<!-- 提示用户登录才能使用相应的功能 -->
<template>
    <el-dialog custom-class="need-login-dialog" :visible.sync="visible" modal-append-to-body>
        <div class="need-login-dialog-content">
            <div>该功能请登录后使用</div>
            <div class="primary-btn" @click="toLogin">立即登录</div>
        </div>
    </el-dialog>
</template>

<script>
export default {
    props: {
        inHome: {
            type: Boolean,
            default: false
        }
    },
    data() {
        return {
            visible: false
        }
    },
    methods: {
        /**
         * 打开对话框
         */
        open() {
            this.visible = true
        },
        /**
         * 关闭对话框
         */
        close() {
            this.visible = false;
        },
        /**
         * 前往登录
         */
        toLogin() {
            this.close();
            // 前往首页登录
            if (this.inHome) window.scrollTo({ top: 0, left: 0, behavior: 'smooth' });
            else this.$router.push('/home');
        }
    }
}
</script>

<style scoped lang="less">
.need-login-dialog-content {
    text-align: center;
    font-size: 18px;
    color: #1D2129;
    .primary-btn {
        width: 172px;
        height: 44px;
        font-size: 14px;
        line-height: 44px;
        margin: 40px auto 0;
    }
}
</style>

<style lang="less">
.need-login-dialog.el-dialog {
    width: 640px;
    height: 360px;
    background: url(@/assets/img/components/NeedLoginDialog/bg_01.png) no-repeat center;
    background-size: 100%;
    .el-dialog__body {
        padding-top: 170px;
    }
}
</style>
